let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jUUIf")).then(() => parcelRequire('2Ncny'));